<template>
	<div id="english">
		<NavigationBar />

		<!-- <Breadcrumb :productName="Breadcrumb.productName" /> -->


		<EnglishComponen :description = "EnglishComponen.description"
								:features = "EnglishComponen.features"
								:link = "EnglishComponen.link"
								:img = "EnglishComponen.img"
								:imgScale = "EnglishComponen.imgScale"
								:imgPositionX = "EnglishComponen.imgPositionX"
								:imgPositionY = "EnglishComponen.imgPositionY"/>

		<div class="uk-section uk-padding-remove">
			<hr>
		</div>

		<!-- <div class="uk-section">
			<div class="uk-container">
				<div class="uk-flex uk-flex-middle uk-margin-remove-left" uk-grid>
					<router-link to="" class="uk-button uk-button-primary uk-margin-auto" style="border-radius: 10px;x">
						<h3 class="uk-text-uppercase" style="color: rgb(255, 255, 255); padding: 1vw;">buy now</h3>
					</router-link>
				</div>
			</div>
		</div>
 -->
		<Footer />
	</div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Footer from '@/components/Footer.vue'
import MainBannerProduct from '@/components/MainBannerProduct.vue'
import DownloadBanner from '@/components/DownloadBanner.vue'
// import EnglishComponen	from '@/components/EnglishComponen.vue'
import EnglishComponen from '@/components/EnglishComponen.vue'

export default {
	name: 'about',
	components: {
		NavigationBar,
		Breadcrumb,
		MainBannerProduct,
		DownloadBanner,
		// EnglishComponen,
		EnglishComponen,
		Footer
	},
	data () {
		return {
			Breadcrumb: {
				productName: 'about'
			},
			banner: {
				productName: 'lumio',
				tagline: 'your smart home lighting',
				features: ['lighting', 'remote connectivity', 'app control', 'vibrant colors'],
				link: 'https://youtu.be/X-p20C2mugs',
				img: 'lumio-banner-1.png',
				posTop: '-150px',
				posBottom: '-330px',
				imageScale: 'scale(1.2)'
			},
			EnglishComponen: {
				description: 'Adjust to any color to suit your mood or occasion.',
				features: [
					'Warm and Cool Lightning.',
					'Multiple color option.',
					'Contorl Switch from Smart Devices.',
					'Adjustable Brightness (Dim).',
					'Music Synchronization.',
					'Auto timer.',
					'App Connectivity on iOS & Android Devices.'
				],
				price: 'Rp. 123.500,00 include gst',
				link: '',
				img: require('../assets/kls.jpg'),
				imgScale: 'scale(.7)',
				imgTransformX: 'right',
				imgPositionY: '0',
			}
		}
	}
}
</script>

<style>

</style>